import WrapperProvider from "@providers/WrapperProvider";
import HomeContainer from "@containers/HomeContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import Layout from "@components/Layout";
import { getServer } from "@translations/next";
import _ from "lodash";
import StrapiService from "@services/StrapiService";
import StoryArticleService from "@services/StoryArticleService";
import FooterService from "@services/FooterService";
export default function Home(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <HomeContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}
export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "group-home-page");
  const res = await StrapiService.find({ populate: "deep", locale });

  const ourStories = _.get(res, "data.attributes.ourStories.stories.data");
  if (_.isEmpty(ourStories)) {
    try {
      const latestStories = await StoryArticleService.find({
        locale,
        page: 1,
        pageSize: 4,
        populate: ["category", "thumbnail"],
        sort: "publishedAt:desc",
      });
      if (!_.isEmpty(_.get(latestStories, "data"))) {
        _.set(
          res,
          "data.attributes.ourStories.stories.data",
          latestStories.data
        );
      }
    } catch (e) {
      console.error("Error fetching Our Story fallback:", e);
    }
  }

  // Fetch Stay Connected for both hotels (used by StayInspired on group home)
  StrapiService.set("id", "hotel10-stay-connected");
  const resThaoDien = await StrapiService.find({
    populate: "deep",
    locale,
  });
  StrapiService.set("id", "hotel65-stay-connected");
  const resBoutique = await StrapiService.find({
    populate: "deep",
    locale,
  });

  const footerData = await FooterService.fetchByHotel(undefined, locale);
  return {
    pageData: _.get(res, "data", {}),
    stayConnected: {
      "amanaki-thao-dien": _.get(resThaoDien, "data", {}),
      "amanaki-boutique-saigon": _.get(resBoutique, "data", {}),
    },
    footerData,
  };
});
